// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"Ribbon_with-ellipsis---sb","withEllipsis":"Ribbon_with-ellipsis---sb","ribbon":"Ribbon_ribbon---sb","diagonal":"Ribbon_diagonal---sb","text":"Ribbon_text---sb","rtl":"Ribbon_rtl---sb","horizontal":"Ribbon_horizontal---sb","top":"Ribbon_top---sb","bottom":"Ribbon_bottom---sb","shadow":"Ribbon_shadow---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Ribbon/styles.less
// module id = 1452
// module chunks = 0